import {
  type InsuranceProduct,
  InsuranceType
} from '@coolblue-development/next-insurance/insurance-selector';
import { Product } from '@features/add-to-cart-page/typings/Product';

import { mapPersonalPrice } from '../../utils/mapPersonalPrice';
import { type SummaryItem, SummaryItemPaymentType, SummaryItemType } from './SummaryStore.types';

export function mapProductToSummaryItem(product: Product, quantity?: number): SummaryItem {
  return {
    id: product.id,
    name: product.name,
    salesPrice: {
      includingVat: product.salesPrice.includingVat,
      excludingVat: product.salesPrice.excludingVat ?? 0
    },

    paymentType: SummaryItemPaymentType.OneTime,
    type: SummaryItemType.Accessory,
    quantity: quantity || 1,
    showPrice: true,
    personalPrice: mapPersonalPrice(product.personalPrice)
  };
}

export function mapInsuranceProductToSummaryItem(insuranceProduct: InsuranceProduct): SummaryItem {
  return {
    id: insuranceProduct.quoteId ?? insuranceProduct.id,
    name: insuranceProduct.title,
    salesPrice: {
      includingVat: insuranceProduct.premium
        ? insuranceProduct.premium.includingVat
        : insuranceProduct.salesPrice.includingVat
    },
    paymentType:
      insuranceProduct.paymentType === 'monthly'
        ? SummaryItemPaymentType.Monthly
        : SummaryItemPaymentType.OneTime,
    type:
      insuranceProduct.insuranceType === InsuranceType.EXTENDED_WARRANTY
        ? SummaryItemType.ExtendedWarranty
        : SummaryItemType.Insurance,
    quantity: 1,
    showPrice: true
  };
}
